<div class="delete-container mct-flex mct-row mct-justify-center mct-items-center" [wl-busy-overlay]="deleting" [busyCenter]="true">
  <button
    pButton
    type="button"
    [disabled]="IsAnnonymousProfileID"
    class="atlas-btn atlas-btn-danger"
    type="button"
    (click)="deleteProfile(profile)"
  >
    {{ 'profiles.edit.delete-profile.delete-this-profile' | translate | uppercase }}
  </button>
</div>

<p-confirmDialog
  #cd
  key="deleteProfile"
  header="{{
    'profiles.edit.delete-profile.delete-confirm-header' | translate: { profile: profile?.ReportName, profileId: profile?.ProfileId }
  }}"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="cd.onAccept()">
      {{ 'profiles.edit.delete-profile.delete-this-profile' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
